var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.654 14C17.884 14.516 18 15.09 18 15.72C18 17.062 17.476 18.112 16.429 18.867C15.38 19.622 13.933 20 12.086 20C10.6332 20 9.1937 19.701 7.76687 19.1023C7.42704 18.9597 7.216 18.6211 7.216 18.2526C7.216 17.518 8.01874 17.0509 8.70443 17.3144C9.74738 17.7154 10.8065 17.916 11.882 17.916C14.433 17.916 15.712 17.184 15.721 15.719C15.7263 15.422 15.6716 15.1269 15.5603 14.8515C15.4489 14.5761 15.2832 14.3259 15.073 14.116L14.953 13.999H4.5C3.94772 13.999 3.5 13.5513 3.5 12.999C3.5 12.4467 3.94772 11.999 4.5 11.999H20.5C21.0523 11.999 21.5 12.4467 21.5 12.999C21.5 13.5513 21.0523 13.999 20.5 13.999H17.654V14ZM13.5195 10.9805C13.5302 10.9842 13.5275 11 13.5162 11H8.13287C8.13038 11 8.12798 10.9991 8.12614 10.9974C7.95208 10.8384 7.7921 10.6646 7.648 10.478C7.216 9.92 7 9.246 7 8.452C7 7.216 7.466 6.165 8.397 5.299C9.33 4.433 10.771 4 12.722 4C14.004 4 15.2382 4.24914 16.4232 4.74743C16.7459 4.88311 16.944 5.206 16.944 5.55603C16.944 6.25972 16.172 6.71303 15.5032 6.49425C14.7117 6.23534 13.8767 6.106 12.998 6.106C10.518 6.106 9.279 6.888 9.279 8.452C9.279 8.872 9.497 9.238 9.933 9.551C10.369 9.864 11.546 10.301 11.546 10.301L13.5195 10.9805Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/Strikethrough.2e18318d7a8b1bebb2eff9daf8374a99.svg";
export { ForwardRef as ReactComponent };